import path from 'path';

const RoutingTree = {
  root: {
    path: '/',
    clienti: {
      path: '/clienti',
      pathName: 'clienti',
      anagrafica: {
        path: '/clienti/anagrafica',
        pathName: 'anagrafica',
      },
      carrello: { path: '/clienti/carrello', pathName: 'carrello' },
      storicoCarrello: {
        path: '/clienti/storico-carrello',
        pathName: 'storico-carrello',
      },
      storicoDocumenti: {
        path: '/clienti/storico-documenti',
        pathName: 'storico-documenti',
      },
      optometria: { path: '/clienti/optometria', pathName: 'optometria' },
      chat: { path: '/clienti/chat', pathName: 'chat' },
      occhialiBuste: {
        path: '/clienti/occhiali-buste',
        pathName: 'occhiali-buste',
      },
      lentiAContatto: {
        path: '/clienti/lenti-a-contatto',
        pathName: 'lenti-a-contatto',
      },
      analisiVisiva: {
        path: '/clienti/analisi-visiva',
        pathName: 'analisi-visiva',
      },
      immagini: { path: '/clienti/immagini', pathName: 'immagini' },
      misurazioni: {
        path: '/clienti/misurazioni',
        pathName: 'misurazioni',
      },
    },
    amministrazione: {
      pathName: 'amministrazione',
      path: '/amministrazione',
      scadenzario: {
        path: '/amministrazione/scadenzario',
        pathName: 'scadenzario',
      },
      scadenzarioClienti: {
        path: '/amministrazione/scadenzario-clienti',
        pathName: 'scadenzario-clienti',
      },
      corrispettivi: {
        path: '/amministrazione/corrispettivi',
        pathName: 'corrispettivi',
      },
      primaNotaCassa: {
        path: '/amministrazione/prima-nota-cassa',
        pathName: 'prima-nota-cassa',
      },
    },
    export: {
      pathName: 'export',
      path: '/export',
    },
    analisi: {
      pathName: 'analisi',
      path: '/analisi',
      clienti: { path: '/analisi/clienti', pathName: 'clienti' },
      magazzino: { path: '/analisi/magazzino', pathName: 'magazzino' },
      agenda: { path: '/analisi/agenda', pathName: 'agenda' },
    },
    bi: {
      pathName: 'bi',
      path: '/bi',
      clienti: { path: '/bi/clienti', pathName: 'clienti' },
      magazzino: { path: '/bi/magazzino', pathName: 'magazzino' },
      agenda: { path: '/bi/agenda', pathName: 'agenda' },
    },
    archivi: {
      pathName: 'archivi',
      path: '/archivi',
      rubrica: { path: '/archivi/rubrica', pathName: 'rubrica' },
      oculisti: { path: '/archivi/oculisti', pathName: 'oculisti' },
      laboratoriEsterni: {
        path: '/archivi/laboratori-esterni',
        pathName: 'laboratori-esterni',
      },
      clientiIngrosso: {
        path: '/archivi/clienti-ingrosso',
        pathName: 'clienti-ingrosso',
      },
      fornitori: { path: '/archivi/fornitori', pathName: 'fornitori' },
    },
    blubooking: {
      pathName: 'agenda',
      path: '/agenda',
      calendarioAppuntamenti: {
        path: '/agenda/calendario-appuntamenti',
        pathName: 'calendario-appuntamenti',
      },
      calendarioPersonale: {
        path: '/agenda/calendario-personale',
        pathName: 'calendario-personale',
      },
      giornalieroUtente: {
        path: '/agenda/giornaliero-utente',
        pathName: 'giornaliero-utente',
      },
      giornalieroStudio: {
        path: '/agenda/giornaliero-studio',
        pathName: 'giornaliero-studio',
      },
      storicoNotifiche: {
        path: '/agenda/storico-notifiche',
        pathName: 'storico-notifiche',
      },
      turniOrari: {
        path: '/agenda/turni-orari',
        pathName: 'turni-orari',
      },
      analisi: {
        path: '/agenda/analisi',
        pathName: 'analisi',
      },
    },
    cataloghi: {
      pathName: 'cataloghi',
      path: '/cataloghi',
      montature: { path: '/cataloghi/montature', pathName: 'montature' },
      lentiAContatto: {
        path: '/cataloghi/lenti-a-contatto',
        pathName: 'lenti-a-contatto',
      },
      lentiOftalmiche: {
        path: '/cataloghi/lenti-oftalmiche',
        pathName: 'lenti-oftalmiche',
      },
    },
    configurazione: {
      pathName: 'configurazione',
      path: '/configurazione',
      puntiVendita: {
        path: '/configurazione/punti-vendita',
        pathName: 'punti-vendita',
      },
      utenti: { path: '/configurazione/utenti', pathName: 'utenti' },
      servizi: { path: '/configurazione/servizi', pathName: 'servizi' },
      chiaviApi: { path: '/configurazione/api-key', pathName: 'chiavi-api' },
      webhooks: { path: '/configurazione/webhooks', pathName: 'webhooks' },
      studi: { path: '/configurazione/studi', pathName: 'studi' },
      bluSign: {
        path: '/configurazione/layout-blu-sign',
        pathName: 'layout-blu-sign',
      },
      layoutApp: {
        path: '/configurazione/layout-il-mio-ottico',
        pathName: 'layout-il-mio-ottico',
      },
      comunicazioniLayout: {
        path: '/configurazione/layout-comunicazioni',
        pathName: 'layout-comunicazioni',
      },
      terminaliAbilitati: {
        path: '/configurazione/terminali-abilitati',
        pathName: 'terminali-abilitati',
      },
      documenti: {
        path: '/configurazione/documenti',
        pathName: 'documenti',
      },
      aziende: {
        path: '/configurazione/aziende',
        pathName: 'aziende',
      },
      profili: {
        path: '/configurazione/profili',
        pathName: 'profili',
      },
      anagraficaMagazzino: {
        path: '/configurazione/anagrafica-magazzino',
        pathName: 'anagrafica-magazzino',
        marchi: {
          path: '/configurazione/anagrafica-magazzino/marchi',
          pathName: 'marchi',
        },
        varie: {
          path: '/configurazione/anagrafica-magazzino/varie',
          pathName: 'varie',
        },
      },
      agenda: { path: '/configurazione/agenda', pathName: 'agenda' },
      layoutBluBooking: {
        path: '/configurazione/layout-blu-booking',
        pathName: 'layout-blu-booking',
      },
      layoutAgenda: {
        path: '/configurazione/layout-agenda',
        pathName: 'layout-agenda',
      },
      layoutSms: {
        path: '/configurazione/layout-sms',
        pathName: 'layout-sms',
      },
      layoutWhatsapp: {
        path: '/configurazione/layout-whatsapp',
        pathName: 'layout-whatsapp',
      },
      anagraficaAmministrazione: {
        path: '/configurazione/anagrafica-amministrazione',
        pathName: 'anagrafica-amministrazione',
        modalitaPagamento: {
          path: '/configurazione/anagrafica-amministrazione/modalita-di-pagamento',
          pathName: 'modalita-di-pagamento',
        },
        tipoPagamento: {
          path: '/configurazione/anagrafica-amministrazione/tipo-pagamento',
          pathName: 'tipo-pagamento',
        },
        istitutiCredito: {
          path: '/configurazione/anagrafica-amministrazione/istituti-di-credito',
          pathName: 'istituti-di-credito',
        },
        categoria: {
          path: '/configurazione/anagrafica/categoria',
          pathName: 'categoria',
        },
        aliquoteIva: {
          path: '/configurazione/anagrafica/aliquote-iva',
          pathName: 'aliquote-iva',
        },
      },
      anagraficaDocumenti: {
        path: '/configurazione/anagrafica-documenti',
        pathName: 'anagrafica-documenti',
        vettori: {
          path: '/configurazione/anagrafica-documenti/vettori',
          pathName: 'vettori',
        },
        causaliDDT: {
          path: '/configurazione/anagrafica-documenti/causali-ddt',
          pathName: 'causali-ddt',
        },
      },
      anagraficaClienti: {
        path: '/configurazione/anagrafica-clienti',
        pathName: 'anagrafica-clienti',
        titoli: {
          path: '/configurazione/anagrafica-clienti/titoli',
          pathName: 'titoli',
        },
        gruppi: {
          path: '/configurazione/anagrafica-clienti/gruppi',
          pathName: 'gruppi',
        },
        professione: {
          path: '/configurazione/anagrafica-clienti/professione',
          pathName: 'professione',
        },
        problemaVisivo: {
          path: '/configurazione/anagrafica-clienti/problema-visivo',
          pathName: 'problema-visivo',
        },
        hobby: {
          path: '/configurazione/anagrafica-clienti/hobby',
          pathName: 'hobby',
        },
        pervenutoTramite: {
          path: '/configurazione/anagrafica-clienti/pervenuto-tramite',
          pathName: 'pervenuto-tramite',
        },
        tagClienti: {
          path: '/configurazione/anagrafica-clienti/tag-clienti',
          pathName: 'tag-clienti',
        },
        anagraficaCitta: {
          path: '/configurazione/anagrafica-clienti/anagrafica-citta',
          pathName: 'anagrafica-citta',
        },
      },
      anagraficaSottoschede: {
        path: '/configurazione/anagrafica-sottoschede',
        pathName: 'anagrafica-sottoschede',
        motivoRichiamo: {
          path: '/configurazione/anagrafica-sottoschede/motivo-richiamo',
          pathName: 'motivo-richiamo',
        },
        controllatoDa: {
          path: '/configurazione/anagrafica-sottoschede/controllato-da',
          pathName: 'controllato-da',
        },
        problemaVisivoLac: {
          path: '/configurazione/anagrafica-sottoschede/problema-visivo-lac',
          pathName: 'problema-visivo-lac',
        },
        liquidi: {
          path: '/configurazione/anagrafica-sottoschede/liquidi',
          pathName: 'liquidi',
        },
      },
      impostazioni: {
        path: '/configurazione/impostazioni',
        pathName: 'impostazioni',
        clienti: {
          path: '/configurazione/impostazioni/clienti',
          pathName: 'clienti',
        },
        privacy: {
          path: '/configurazione/impostazioni/privacy',
          pathName: 'privacy',
        },
        iva: {
          path: '/configurazione/impostazioni/iva',
          pathName: 'iva',
        },
        schedaOptometrica: {
          path: '/configurazione/impostazioni/scheda-optometrica',
          pathName: 'scheda-optometrica',
        },
        lentiAContatto: {
          path: '/configurazione/impostazioni/lenti-a-contatto',
          pathName: 'lenti-a-contatto',
        },
        busta: {
          path: '/configurazione/impostazioni/busta',
          pathName: 'busta',
        },
        carrello: {
          path: '/configurazione/impostazioni/carrello',
          pathName: 'carrello',
        },
        documenti: {
          path: '/configurazione/impostazioni/documenti',
          pathName: 'documenti',
        },
        focusCard: {
          path: '/configurazione/impostazioni/focus-card',
          pathName: 'focus-card',
        },
        moduliAggiuntivi: {
          path: '/configurazione/impostazioni/moduli-aggiuntivi',
          pathName: 'moduli-aggiuntivi',
        },
        sellOut: {
          path: '/configurazione/impostazioni/sell-out',
          pathName: 'sell-out',
        },
        serviziLocali: {
          path: '/configurazione/impostazioni/servizi-locali',
          pathName: 'servizi-locali',
        },
        mail: {
          path: '/configurazione/impostazioni/mail',
          pathName: 'mail',
        },
        stampeClienti: {
          path: '/configurazione/impostazioni/stampe-clienti',
          pathName: 'stampe-clienti',
        },
      },
    },
    crm: {
      pathName: 'crm',
      path: '/crm',
      attivitaPianificate: {
        path: '/crm/attivita-pianificate',
        pathName: 'attivita-pianificate',
      },
      assistenza: {
        path: '/crm/assistenza',
        pathName: 'assistenza',
      },
      guide: {
        path: '/crm/guide',
        pathName: 'guide',
      },
      analisi: {
        path: '/crm/analisi',
        pathName: 'analisi',
        campagne: {
          path: '/crm/analisi/analisi-campagne',
          pathName: 'analisi-campagne',
        },
        attivitaCicliche: {
          path: '/crm/analisi/analisi-attivita-cicliche',
          pathName: 'analisi-attivita-cicliche',
        },
      },
      clientiDaContattare: {
        path: '/crm/clienti-da-contattare',
        pathName: 'clienti-da-contattare',
      },
      conflitti: {
        path: '/crm/conflitti',
        pathName: 'conflitti',
      },
      richiamiTelefonici: {
        path: '/crm/richiami-telefonici',
        pathName: 'richiami-telefonici',
      },
      ecommerce: {
        path: '/crm/ecommerce',
        pathName: 'ecommerce',
      },
      impostazioni: {
        path: '/crm/impostazioni',
        pathName: 'impostazioni',
        generali: {
          path: '/crm/impostazioni/generali',
          pathName: 'generali',
        },
        gruppiCrm: {
          path: '/crm/impostazioni/gruppi-crm',
          pathName: 'gruppi-crm',
        },
      },
      app: {
        path: '/crm/app',
        pathName: 'app',
        dashboard: {
          path: '/crm/app/dashboard',
          pathName: 'dashboard',
        },
        chatStorico: {
          path: '/crm/app/chat-storico',
          pathName: 'chat-storico',
        },
        richiesteOrdine: {
          path: '/crm/app/richieste-ordine',
          pathName: 'richieste-ordine',
        },
        chatDaLeggere: {
          path: '/crm/app/chat-da-leggere',
          pathName: 'chat-da-leggere',
        },
        visionCard: {
          path: '/crm/app/vision-card',
          pathName: 'vision-card',
        },
        clientiApp: {
          path: '/crm/app/clienti-app',
          pathName: 'clienti-app',
        },
        clientiAppAttivi: {
          path: '/crm/app/clienti-app-attivi',
          pathName: 'clienti-app-attivi',
        },
      },
      canaliEsterni: {
        path: '/crm/canali-esterni',
        pathName: 'canali-esterni',
      },
      campagne: {
        path: '/crm/campagne',
        pathName: 'campagne',
        centroOttico: {
          path: '/crm/campagne/centro-ottico',
          pathName: 'centro-ottico',
        },
        template: {
          path: '/crm/campagne/template',
          pathName: 'template',
        },
        fornitori: {
          path: '/crm/campagne/fornitori',
          pathName: 'fornitori',
        },
      },
      attivitaCicliche: {
        path: '/crm/attivita-cicliche',
        pathName: 'attivita-cicliche',
        centroOttico: {
          path: '/crm/attivita-cicliche/centro-ottico',
          pathName: 'centro-ottico',
        },
        template: {
          path: '/crm/attivita-cicliche/template',
          pathName: 'template',
        },
        fornitori: {
          path: '/crm/attivita-cicliche/fornitori',
          pathName: 'fornitori',
        },
      },
    },
    home: {
      pathName: 'home',
      path: '/home',
    },
    documenti: {
      pathName: 'documenti',
      path: '/documenti',
      nomeDocumento: {
        path: '/documenti/:nomeDocumento',
        pathName: ':nomeDocumento',
        idDocumento: {
          path: '/documenti/:nomeDocumento/:codiceFilialeDocumento',
          pathName: ':codiceFilialeDocumento',
        },
      },
    },
    laboratorio: {
      pathName: 'laboratorio',
      path: '/laboratorio',
    },
    listino: {
      path: '/listino',
      pathName: 'listino',
      montature: {
        path: '/listino/montature',
        pathName: 'montature',
      },
      lentiOftalmiche: {
        path: '/listino/lenti-oftalmiche',
        pathName: 'lenti-oftalmiche',
      },
      lentiAContatto: {
        path: '/listino/lenti-a-contatto',
        pathName: 'lenti-a-contatto',
      },
      liquidiEdAccessori: {
        path: '/listino/liquidi-accessori',
        pathName: 'liquidi-accessori',
      },
    },
    magazzino: {
      pathName: 'magazzino',
      path: '/magazzino',
      montature: {
        path: '/magazzino/montature',
        pathName: 'montature',
      },
      lentiOftalmiche: {
        path: '/magazzino/lenti-oftalmiche',
        pathName: 'lenti-oftalmiche',
      },
      lentiAContatto: {
        path: '/magazzino/lenti-a-contatto',
        pathName: 'lenti-a-contatto',
      },
      liquidiEdAccessori: {
        path: '/magazzino/liquidi-accessori',
        pathName: 'liquidi-accessori',
      },
      servizi: {
        path: '/magazzino/servizi',
        pathName: 'servizi',
      },
    },
    ordini: {
      path: '/ordini',
      pathName: 'ordini',
    },
    report: {
      path: '/report',
      pathName: 'report',
    },
    statistiche: {
      path: '/statistiche',
      pathName: 'statistiche',
    },
    supporto: {
      path: '/supporto',
      pathName: 'supporto',
    },
    backoffice: {
      path: '/backoffice',
      pathName: 'backoffice',
      eventi: {
        path: '/backoffice/eventi',
        pathName: 'eventi',
      },
      store: {
        path: '/backoffice/store',
        pathName: 'store',
      },
      messaggiInUscita: {
        path: '/backoffice/messaggi-in-uscita',
        pathName: 'messaggi-in-uscita',
      },
      messaggiInviati: {
        path: '/backoffice/messaggi-inviati',
        pathName: 'messaggi-inviati',
      },
      mailInviate: {
        path: '/backoffice/mail-inviate',
        pathName: 'mail-inviate',
      },
      mailUscita: {
        path: '/backoffice/mail-uscita',
        pathName: 'mail-uscita',
      },
    },
  },
};

/**
 * Mapping tra codiceMagazzino e path del routing.
 * 0 = Montature, 1 = Lenti Oftalmiche, 2 = Lenti a Contatto, 3 = Liquidi ed Accessori, 4 = Servizi
 */
export const magazzinoCodeToPath: Record<number, string> = {
  0: RoutingTree.root.magazzino.montature.path,
  1: RoutingTree.root.magazzino.lentiOftalmiche.path,
  2: RoutingTree.root.magazzino.lentiAContatto.path,
  3: RoutingTree.root.magazzino.liquidiEdAccessori.path,
  4: RoutingTree.root.magazzino.servizi.path,
};

/**
 * Restituisce il path del magazzino in base al codiceMagazzino.
 * Se il codice non è valido, restituisce il path delle montature come default.
 */
export const getMagazzinoPathFromCode = (codiceMagazzino: number): string => {
  return (
    magazzinoCodeToPath[codiceMagazzino] ??
    RoutingTree.root.magazzino.montature.path
  );
};

export default RoutingTree;
